module.exports = __webpack_public_path__ + "img/gp.c1bd7014.svg";